import { Stack, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ISelectedFiltersHeader } from "../../../../interfaces/globalComponents/explore/material/exploreAllFilters/ISelectedFiltersHeaders";
import { TextButton } from "../../../global/buttons/material/textButton/TextButton";
import { removeAllFilters } from "../../../../redux/filtersSlice";

export const SelectedFiltersHeader = ({
  filterFor,
  type,
}: ISelectedFiltersHeader) => {
  const selectedFilters = useSelector((state: RootState) => state.filters);
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );
  const dispatch = useDispatch();

  const handleClearResults = () => {
    dispatch(removeAllFilters({ filterFor, type }));
  };

  if (selectedFilters[filterFor][type]?.length === 0) {
    return;
  }

  return (
    <Stack
      direction="row"
      className="p-[16px] justify-between md:hidden lg:flex"
    >
      <Typography
        sx={{
          color: componentColors.surface.onSurface,
        }}
      >
        {selectedFilters[filterFor][type]?.length} Selected
      </Typography>

      <TextButton text="Clear results" onClick={handleClearResults} />
    </Stack>
  );
};
